import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
var _excluded = ["columns", "children", "className"];
import { jsx } from 'react/jsx-runtime';
import { CompositeProvider, Composite, CompositeRow } from '@ariakit/react';
import clsx from 'clsx';
import chunk from 'lodash/chunk';
import { forwardRef, Children } from 'react';
import styles from './select-menu-grid.module.js';

var Row = function Row(props) {
  return jsx(CompositeRow, _objectSpread(_objectSpread({}, props), {}, {
    className: styles.row,
    role: "row"
  }));
};

var SelectMenuGrid = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var columns = props.columns,
      children = props.children,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded);

  if (new Set(Children.toArray(children).map(function (child) {
    return child === null || child === void 0 ? void 0 : child.type;
  })).size > 1) {
    // eslint-disable-next-line no-console
    console.warn('SelectMenuGrid: all children should be of the same type');
  }

  var childrenByColumns = chunk(Children.toArray(children), columns);
  return jsx(CompositeProvider, {
    children: jsx(Composite, _objectSpread(_objectSpread({}, rest), {}, {
      ref: forwardedRef,
      className: clsx(styles.grid, className),
      role: "grid",
      children: childrenByColumns.map(function (row, i) {
        var _row$;

        return jsx(Row, {
          children: row
        }, ((_row$ = row[0]) === null || _row$ === void 0 ? void 0 : _row$.key) || i);
      })
    }))
  });
});
export { SelectMenuGrid };